import * as React from 'react';
import { useStyles } from './CardSection.styles';
import { Styler, StylerBaseProps } from '../../Styler';

export interface CardSectionProps extends StylerBaseProps {
    /**
     * The card section content.
     */
    children: React.ReactNode;
}

export function CardSection(props: Readonly<CardSectionProps>): React.JSX.Element {
    const { children, ref, ...other } = props;

    const { styles } = useStyles();

    return (
        <Styler ref={ref} baseStyles={styles.root} data-card-section={true} {...other}>
            {children}
        </Styler>
    );
}
